import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { OrdersService } from '../../services/order/orders.service';
import { ProductService } from '../../services/product/product.service';
import { PdvService } from '../../services/pdv/pdv.service';
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PersonalizeProductComponent } from '@app/modules/modals/personalize-product/personalize-product.component';
import { Router } from '@angular/router';

@Component({
    moduleId: module.id,
    selector: 'best-sales',
    templateUrl: 'best-sales.component.html',
    styleUrls: ['best-sales.component.scss']
})
export class BestSalesComponent {
    bestSalesProduct: any[] = [];
    loadBestSales: boolean = true;
    close = false;
    idPdv: string;
    bsModalRef: BsModalRef;
    chosenOrderType: number;
    subscriptions: Subscription[] = [];
    subscriptions2: Subscription[] = [];
    orderType;
    orderProg;
    choos;
    constructor(
        private pdvService: PdvService,
        private productService: ProductService,
        private ordersService: OrdersService,
        private modalService: BsModalService,
        private router: Router
    ) {
        this.idPdv = this.pdvService.idPdv;
        let subs1 = this.ordersService.orderType.subscribe((orderType: number) => {
            this.orderType = orderType;
        });
        const subs5 = this.ordersService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        let subs2 = this.ordersService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.chosenOrderType > 0) {
                this.orderType = chosenOrderType;
            }
            this.getBestSales();
        });
        this.subscriptions2.push(subs1, subs2, subs5);

    }

    PersonalizeModal(i) {
        if (this.chosenOrderType > 0) {
            let product = this.bestSalesProduct[i];
            this.bsModalRef = this.modalService.show(PersonalizeProductComponent, { class: 'modal-content3' });
            this.bsModalRef.content.product = product;
        } else {
            this.router.navigate(["/modes"]);
        }
    }

    getBestSales() {
        this.productService.getBestSales(this.orderType, this.orderProg).toPromise().then(
            (products: any[]) => {
                this.bestSalesProduct = products;
                this.loadBestSales = false;
            }
        )
    }

    addElementToBasket(i) {
        if (this.chosenOrderType > 0) {
            let product = this.bestSalesProduct[i];
            let element = {
                id: product.id,
                code: product.code,
                name: product.name,
                family: product.family,
                size: product.sizes[product.size],
                comment: '',
                qty: 1,
                removedCompositions: [],
                supplements: [],
                optionIngredients: [],
                total: 0,
                vat: product.vat,
                priceSuppApp: product.priceSuppApp,
                priceWithSupp: Number(product.sizes[product.size].price),
                maxNbrIngOptions: product.maxNbrIngOptions,
                hasSupp: product.hasSupp,
                avatar: product.avatar
            }
            element.total += Number(element.size.price);
            element.total *= Number(element.qty);
            this.ordersService.addElementToOrder(element);
        } else {
            this.router.navigate(["/modes"]);
        }
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }
    ngOnDestroy() {
        this.unsubscribe2();
    }
}
